var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector21(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 309,
    viewBox: "0 0 199 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328.206 307.581C304.818 288.666 301.111 284.547 286.295 265.138C282.665 260.383 276.953 251.139 271.498 239.722C269.863 236.305 268.381 232.917 267.022 229.576C257.328 205.669 255.959 178.886 258.212 152.435C263.962 84.9457 227.43 24.0338 172.119 6.27647C116.703 -11.5188 55.1862 17.7414 25.1643 63.4016C21.2583 69.3428 4.0283 97.3787 1.48133 128.138C-6.58723 225.258 87.489 264.066 230.632 293.449C233.417 294.019 246.674 296.192 249.488 296.581L328.215 307.581H328.206Z",
    stroke: "#1E1E22",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector21);
export default __webpack_public_path__ + "static/media/vector2-1.c9d11bbdf6f71882251de29e68e9a932.svg";
export { ForwardRef as ReactComponent };